import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import RegisterWizardPage from './pages/RegisterWizard'
import TaxesKeyAuthPage from './pages/TaxesKeyAuth'
import UniquePassAuthPage from './pages/UniquePassAuth'

/**
 * The Routing' component.
 */
const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route caseSensitive element={<RegisterWizardPage />} path={routes.root} />
        <Route caseSensitive element={<RegisterWizardPage />} path={routes.registerWizard} />
        <Route caseSensitive element={<TaxesKeyAuthPage />} path={routes.taxesKeyAuth} />
        <Route caseSensitive element={<UniquePassAuthPage />} path={routes.uniquePassAuth} />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </BrowserRouter>
  )
}

export default Routing
